<style scoped>
.Netdefault {
    width: 100%;
    min-height: 100vh;
    background: #f3f3f3;
    position: fixed;
    top: 0;
    left: 0;
}
.Netdefault .tipicon {
    width: 30vw;
    height: 100%;
}
.Netdefault .defaultnote {
    color: #999999;
    text-align: center;
    font-size:2.2vh;
    margin: 4vh;
}
</style>

<template>
    <div v-show="isError" class="Netdefault flexcenter">
  <!-- <div v-show="isError" class="Netdefault flexcenter" @click="reloadPage()"> -->
        <div> 
            <div class="flexcenter imgbox">
                <img src="../assets/default/icon_offline.svg" alt="icon" class="tipicon">
            </div>
            <div class="defaultnote">{{ msg || msgdefault}}</div>
      </div>
  </div>
</template>

<script>
import bus from "@/util/bus";

export default {
    name: "NetDefault",
    props: {
        msg: String
    },
    data() {
        return {
            isError: false,
            msgdefault: "网络状况不佳..."
        };
    },
    created() {
        bus.$on("showError", () => this.showError());
    },
    methods: {
        reloadPage() {
            this.isError = false;
            bus.$emit("reloadPage");
        },
        showError() {
            this.isError = true;
        }
    },
    beforeDestroy() {
        bus.$off("showError", this.showError);
    }
};
</script>

